import { Component, OnInit, forwardRef, EventEmitter, Input, Output, OnDestroy } from '@angular/core';
import { FormControl } from '@angular/forms';
import { BaseControlValueAccessor } from '../base-control-value-accessor';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import moment from 'moment-timezone';
import { FormConstants } from '../../../core/globals/form-constants';

@Component({
  selector: 'app-date-picker',
  templateUrl: './date-picker.component.html',
  styleUrls: ['./date-picker.component.scss', '../../styles/form-input.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DatePickerComponent),
      multi: true
    }
  ]
})
export class DatePickerComponent extends BaseControlValueAccessor<Date[]> implements OnInit, OnDestroy {

  @Input() formControl: FormControl;
  @Input() text: string;
  @Input() config: any;
  @Input() disabledDaysInWeek: any;

  @Output() changeCallback = new EventEmitter();

  public settings: any;
  public date: any;
  public maxDates: number;
  private disabledDays: any;
  private watcher: any;
  private datepicker: any;
  private weekDaysMapping: any = FormConstants.weekDaysMapping;

  constructor(){
    super();
  }

  ngOnInit() {
    this.maxDates = Number(this.config && this.config.values ? this.config.values[0] : 1);
    this.disabledDays = [];
    if (this.config && this.config.disabledDaysInWeek){
      this.disabledDays = this.config.disabledDaysInWeek.map(day => {
        return this.weekDaysMapping[day];
      });
    }
    this.settings = {
      display: 'bubble',
      select: this.maxDates,
      onSet: this.onInputChange,
      dateFormat: 'dd/mm/yyyy',
      min: (this.config && this.config.minDate) ? this.config.minDate.toDate() : '',
      max: (this.config && this.config.maxDate) ? this.config.maxDate.toDate() : '',
      invalid: this.disabledDays,
      onInit: (event: any, inst: any) => {
        this.datepicker = inst;
      }
    };
    if (this.formControl && this.formControl.value) {
      this.onFormControlChange();
    }
    if (this.formControl) {
      this.watcher = this.formControl.valueChanges.subscribe(this.onFormControlChange.bind(this));
    }
  }

  onFormControlChange = () => {
    const dateArray = this.formControl.value.map((momentObj) => momentObj.toDate());
    this.date = this.maxDates > 1 ? dateArray : dateArray[0];
  }

  onInputChange = (): void => {
    const dateArray = this.maxDates > 1 ? this.date : [this.date];
    const momentArray = dateArray.map((date) => moment(date.getTime()));
    const prevValue = this.value;
    this.value =  momentArray;
    this.onChange(this.value);
    if (this.changeCallback) {
      this.changeCallback.emit({ next: this.value, prev: prevValue});
    }
  }

  showError(): boolean {
    return Boolean(this.formControl && this.formControl.errors && this.formControl.dirty);
  }

  ngOnDestroy() {
    if (this.watcher) {
      this.watcher.unsubscribe();
    }
  }

}
